<rotec-pages-v2>
  <a [routerLink]="assetsLink" routerLinkActive="pages-active-link" id="assetsCount">
    <h3 translate>Assets</h3>
    <p>
      {{ nrOfAssets$ | async }}
    </p>
  </a>
  <a [routerLink]="groupsLink" routerLinkActive="pages-active-link" id="groups">
    <h3 translate>Groups</h3>
    <p>
      {{ nrOfGroups$ | async }}
    </p>
  </a>
  <a [routerLink]="plantsLink" routerLinkActive="pages-active-link" id="plants">
    <h3 translate>Plants</h3>
    <p>{{ nrOfPlants$ | async }}</p>
  </a>
  <a [routerLink]="serviceHelpDeskLink" routerLinkActive="pages-active-link" id="tickets">
    <h3 translate>Help Desk</h3>
    <p></p>
  </a>
</rotec-pages-v2>
